import EditorImg from 'lowcode/components/EditorImg';
import styles from './index.module.scss';

export default function CardC() {
    return (
        <div className={styles.comp}>
            <div className="comp-title">What can EcoFlow's solution offer?</div>
            <div className="comp-list">
                <div className="comp-item">
                    <div className="comp-item-img">
                        <EditorImg pc="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1716799732043/aab11.jpg" h5="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1716799745891/aab12.jpg" />
                    </div>
                    <div className="comp-item-msg">
                        <div className="comp-item-title">Always on track of Time-of-Use (TOU) Rates</div>
                        <div className="comp-item-desc">
                        End peak price electricity bill worries all year round. Our system manages everything seamlessly, so you never have to keep track of or restrict electricity usage. 
                        </div>
                    </div>
                </div>
                <div className="comp-item">
                    <div className="comp-item-img">
                        <EditorImg pc="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1716799812229/aab21.jpg" h5="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1716800139983/aab22.jpg" />
                    </div>
                    <div className="comp-item-msg">
                        <div className="comp-item-title">Always Enjoy Off-Peak Rates</div>
                        <div className="comp-item-desc">
                        Effortlessly power your appliances at any time with no concern for peak hours. Our system ends the frustration of restricting your energy use by ensuring you always benefit from off-peak pricing.
                        </div>
                    </div>
                </div>
                <div className="comp-item">
                    <div className="comp-item-img">
                        <EditorImg pc="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1716800204796/aab31.jpg" h5="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1716800219592/aab32.jpg" />
                    </div>
                    <div className="comp-item-msg">
                        <div className="comp-item-title">Cut Bills with Time-of-Use (TOU) Rates</div>
                        <div className="comp-item-desc">Automatically save money by using stored power during peak rate hours.</div>
                    </div>
                </div>
            </div>
        </div>
    );
}
